import { Helmet } from "react-helmet";
import {
    Box,
    ClickAwayListener,
    Stack,
    MenuItem,
    MenuList,
    Divider,
    InputAdornment,
    TextField,
    Tab,
    Tabs,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    usePagination,
    Grow,
    Popper,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Stepper,
    Step,
    StepLabel,
    Switch,
    TableCell,
    TableRow,
    TableBody,
    Table,
    TableHead,
    FormHelperText,
    Paper,
    Card,
    CardContent,
    ToggleButton,
    ToggleButtonGroup,
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { useTranslation } from "react-i18next";
import AccessibleIcon from "@mui/icons-material/Accessible";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import React, { useEffect, useMemo, useCallback } from "react";
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import adminService from "../../../../services/admin.service";
import cssVariables from "../../../../theme/cssVariables";
import { ReactComponent as Doner } from "../../../../assets/icons/doner.svg";
import { ReactComponent as XIcon } from "../../../../assets/icons/xIcon.svg";
import SimpleDialog from "../../../../components/SimpleDialog";
import Icon from '@mui/material/Icon';
import { useSelector, useDispatch } from "react-redux";
import { min, set } from "date-fns";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { makeStyles, styled } from "@mui/styles";
import Summary360 from './summary360';
import { ReactComponent as Delete } from "../../../../assets/icons/delete.svg";
import dayjs from 'dayjs'
import { ReactComponent as InfoCircleIcon } from "../../../../assets/icons/info-circle.svg"
import CustomTooltip from "../../../../components/CustomTooltip"
import ReactECharts from 'echarts-for-react'
import { ReactComponent as Plus } from "../../../../assets/icons/plus.svg";

const colorsPallet = ['#5DA196', '#77C47C', '#FF9921', '#8DCCF0', '#FFC24D']

const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    leftRotateLabel: {
        width: "40px",
        height: "100%",
        display: "flex",
        justifyContent: "center"
    },
    leftRotateLabelLineHeight: 8,
};


const ManageForm = (props) => {
    const { cycleType, show360, type, serial, cycleList, cycle, code, workflowList, evaluationComponent, customFormList, competencyType, changeStepTo1, options, cycleID, oldData } = props
    const useStyles = makeStyles({
        fillGrey: {
            '& > path': {
                stroke: "#D8D8D8 !important"
            },
            '& g > path': {
                stroke: "#D8D8D8 !important"
            },
        },
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },
        inputGroupScore: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },
        inputDate: {
            '& div > input': {
                height: '25px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },
        inputDateError: {
            '& div > input': {
                height: '25px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            },
            '& fieldset': {
                "border-color": "#CC6058 !important"
            }
        },
        inputError: {
            '& div > input': {
                color: "#CC6058",
                height: '8px',
                position: "relative",
                borderRadius: "4px"
            },
            '& fieldset': {
                borderColor: "#CC6058 !important",
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },

        requiredTitle: {
            color: '#404349',
            fontWeight: '500 !important',
            fontSize: '18px !important'
        },

        textShow: {
            color: '#AAAAAA',
            fontWeight: "500 !important",
            fontSize: '18px !important',
        },

        textShowLittle: {
            color: '#AAAAAA',
            fontWeight: 300,
            fontSize: '16px',
        },

        textShowSmall: {
            color: '#A0A0A0',
            fontWeight: 500,
            fontSize: '14px',
        },

        titleName: {
            color: '#404349',
            fontSize: '24px !important',
            fontWeight: '600 !important'
        },

        textError: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#CC6058',
        },

        root: {
            '& .MuiSvgIcon-root.Mui-active': { color: '#f7b254' },
            "& .MuiStepIcon-root .MuiStepIcon-completed": { color: "#5da196" },
            "& .Mui-disabled .MuiStepIcon-root": { color: "#404349" },
            "& .MuiStepConnector-root span": { border: '0px', borderTop: '1.5px dashed #d7d7d7' },
            "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": { color: "#5da196", fontWeight: 400, fontSize: '16px' },
            "& .MuiStepLabel-label.Mui-disabled.MuiStepLabel-alternativeLabel": { color: "#404349", fontWeight: 400, fontSize: '16px' },
            "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": { color: "#f7b254", fontWeight: 400, fontSize: '16px' },
            '& .Mui-active .MuiStepIcon-text': { display: 'none' },
            '& .Mui-disabled .MuiStepIcon-text': { display: 'none' },
            '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': { marginTop: '5px' }
        },

        evaluationBox: {
            border: '1px solid #CED4DA',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '23px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        evaluationBoxRequired: {
            border: '1px solid #CC6058',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '23px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        summaryTable: {
            border: '1px solid #CED4DA',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '30px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        checkboxLabel: {
            color: '#404349',
            fontWeight: '400',
            fontSize: '16px'
        },

        checkboxLabelHighlight: {
            color: '#5DA196',
            fontWeight: '600 !important',
            fontSize: '16px'
        },

        table: {
            borderTop: '1px solid #E5E5E5',
            marginTop: '21px',
        },

        tableSummary: {
            marginTop: '0px',
        },

        tableHead: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '30px',
                backgroundColor: '#FAFAFA',
                fontSize: '14px',
                fontWeight: '500',
                color: '#A0A0A0'
            }
        },

        tableHeadBigger: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '50px',
                backgroundColor: '#FAFAFA',
                fontSize: '14px',
                fontWeight: '500',
                color: '#A0A0A0'
            }
        },

        tableBody: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '50px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyWithoutBorder: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                height: '50px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyGoal: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '70px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyReview: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '80px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        checkBoxStyle: {
            color: '#CED4DA',
            '&.Mui-checked': {
                color: '#5DA196',
            },
            paddingLeft: '0px',
            '&.Mui-disabled': {
                pointerEvents: 'auto',
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                cursor: 'not-allowed',
                '& .MuiSvgIcon-root': {
                    backgroundColor: '#E4E4E4',
                    borderColor: '#CED4DA'
                },
            },
        },

        checkBoxForShow: {
            color: '#D8D8D8',
            '&.Mui-checked': {
                color: '#D8D8D8',
                fontSize: '20px'
            },
        },

        disabledBox: {
            border: '1px solid #CED4DA',
            backgroundColor: '#E4E4E4',
            borderRadius: 1,
            width: '20px',
            height: '20px',
            margin: '0 auto',
        },

        disabled: {
            background: "#E4E4E4!important",
            color: '#AAAAAA!important',
            "& .MuiInputBase-input": {
                "background-color": "#E4E4E4",
                "-webkit-text-fill-color": "#AAAAAA !important"
            },
            "fieldset": {
                "border-color": "#CED4DA !important"
            },
            '& div > input': {
                height: '8px',
                position: "relative"
            },
        },
        '& Mui-disabled': {
            background: "#E4E4E4!important",
            color: '#AAAAAA!important'
        },
        fillRed: {
            '& > path': {
                fill: "#CC6058"
            },
            '& g > path': {
                fill: "#CC6058"
            },
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopic: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicError: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058 !important"
            }
        },
        inputTopicDisabledTextarea: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicTextarea: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicErroTextarear: {
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '8px',
                position: "relative"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        select: {
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        selectError: {
            '& div ': {
                padding: "4.05px 14px"
            },
            '& fieldset': {
                "border-color": "#CC6058"
            }
        },
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
        strokeDisabled: {
            '& > path': {
                stroke: 'rgba(0, 0, 0, 0.26)'
            },
            '& g > path': {
                stroke: 'rgba(0, 0, 0, 0.26)'
            },
        },
        cardStyle: {
            borderRadius: "10px!important",
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
        },
        barLegend: {
            fontSize: "14px",
            lineHeight: "19px",
        }
    })
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = React.useState(0);
    const [steps, setSteps] = React.useState(["Template Code", "Evaluation Template", "Evaluation Component", "Result", "Evaluation Summary"])
    const [codeExist, setCodeExist] = React.useState(false);
    const [status, setStatus] = React.useState(true);
    const [isUsed, setIsUsed] = React.useState(false);
    const [checkStep1, setcheckStep1] = React.useState(false);
    const [checkStep2, setcheckStep2] = React.useState(false);
    const [require_evaluator_comment, setRequireEvaluatorComment] = React.useState(false);
    const [previewWorkflow, setPreviewWorkflow] = React.useState([]);
    const [previewWorkflowSave, setPreviewWorkflowSave] = React.useState([]);
    const [evaluationComponents, setEvaluationComponents] = React.useState([]);
    const [selectEvaluationComponents, setSelectEvaluationComponents] = React.useState("");
    const [custom, setCustom] = React.useState("");
    const [decimal, setDecimal] = React.useState("");
    const [competencyTypeData, setCompetencyTypeData] = React.useState([]);
    const [competencyTypeSave, setCompetencyTypeSave] = React.useState([]);
    const [commentQuestionsData, setCommentQuestionsData] = React.useState([{ "serial": "", "topic": "", "is_required": false }]);
    const [commentQuestionsSave, setCommentQuestionsSave] = React.useState([{ "serial": "", "topic": "", "is_required": false }]);
    const [firstDates, setFirstDate] = React.useState([]);
    const [lastDates, setLastDate] = React.useState([]);
    const [evaluateTemplateEvaluator, setEvaluateTemplateEvaluator] = React.useState([
        {
            "type": "self",
            "weight": "",
            "display_min": "0",
            "assign_type": "",
            "name": "Self",
            "assign_option": null,
            "status": "active"
        },
        {
            "type": "superior",
            "name": "Superior",
            "weight": "",
            "display_min": "",
            "assign_type": "",
            "status": "inactive",
            "assign_option": {
                "by_direct_report": {
                    "min": "",
                },
                "by_self": {
                    "min": "",
                }
            }
        },
        {
            "type": "subordinate",
            "name": "Subordinate",
            "weight": "",
            "display_min": "",
            "assign_type": "",
            "status": "inactive",
            "assign_option": {
                "by_direct_report": {
                    "min": "",
                },
                "by_self": {
                    "min": "",
                }
            }
        },
        {
            "type": "peer",
            "name": "Peer",
            "weight": "",
            "display_min": "",
            "assign_type": "",
            "status": "inactive",
            "assign_option": {
                "by_direct_report": {
                    "min": "",
                },
                "by_self": {
                    "min": "",
                }
            }
        }
    ]);
    const [evaluateTemplateEvaluatorShow, setEvaluateTemplateEvaluatorShow] = React.useState([
        {
        },
        {

        },
        {

        },
        {

        }
    ]);
    const [isSuccessOpen, openSuccessOpen] = React.useState(false);

    const handleSuccess = () => {
        openSuccessOpen(false);
        clickLink('/admin/evaluation-journey');
    };
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycleID } });
    }
    const [scoreDecimal, setScoreDecial] = React.useState([
        { serial: "0", code: "0" },
        { serial: "1", code: "1" },
        { serial: "2", code: "2" },
        { serial: "3", code: "3" },
        { serial: "4", code: "4" }
    ]);

    const [onSubmit, setOnSubmit] = React.useState(false);

    const validationSchema = yup.object({
        XAxis: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        YAxis: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });
    const formik = useFormik({
        initialValues: {
            code: "",
            serial: "",
            cycle: {
                serial: ""
            },
            status: "active",
            evaluate_journey_data: {
                name_th: "",
                name_en: "",
                description_th: "",
                description_en: "",
                evaluation_type: {
                    serial: ""
                },
                total_score: "",
                others_component: {},
                expected_rating: {},
                serial: "",
                hide_evaluator_to_self: false,
                is_enforce_start: false
            },
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
        },
        handleBlur: (v) => {
        }
    });

    const addQuestion = () => {
        let item = JSON.parse(JSON.stringify(commentQuestionsSave))
        setCommentQuestionsSave([...item, { "serial": "", "topic": "", "is_required": false }])
        setCommentQuestionsData([...item, { "serial": "", "topic": "", "is_required": false }])
    }

    const formikChange = (val, field, options) => {
        formik.setFieldValue(field, val.target.value)
    }

    useEffect(() => {
        if (cycleType === "360" && show360 === true) {
            setActiveStep(1)
        } else if (activeStep !== 0) {
            setActiveStep(0)
        }
    }, [show360, cycleType]);

    useEffect(() => {
        if (selectEvaluationComponents === "competency") {
            setMin(Util.formatData(options?.competency?.scale_min, 0))
            setMax(Util.formatData(options?.competency?.scale_max, 0))
        }
    }, [selectEvaluationComponents, options]);

    useEffect(() => {
        if (selectEvaluationComponents === "custom") {
            let data = Util.formatData(options?.custom_form, []).filter((rs) => rs?.custom_form_id === custom)
            if (data.length > 0) {
                setMin(Util.formatData(data[0]?.scale_min, 0))
                setMax(Util.formatData(data[0]?.scale_max, 0))
            }
        }
    }, [custom, options]);

    useEffect(() => {
        setEvaluationComponents(Util.formatData(evaluationComponent, []))
    }, [evaluationComponent]);

    useEffect(() => {
        let oldDataEvaluateJourney = []
        if (Util.formatData(oldData?.evaluate_journey_data?.evaluate_competency_template?.competency_type, []) > 0) {
            oldDataEvaluateJourney = oldData?.evaluate_journey_data?.evaluate_competency_template?.competency_type

        }
        let data = Util.formatData(competencyType, []).map((rs) => ({
            ...rs,
            "selected": Util.formatData(Util.formatData(oldData?.evaluate_journey_data?.evaluate_competency_template?.competency_type, []).filter((dt) => dt?.serial === rs?.serial)[0]?.weight >= 0, false),
            "weight": Util.formatData(Util.formatData(oldData?.evaluate_journey_data?.evaluate_competency_template?.competency_type, []).filter((dt) => dt?.serial === rs?.serial)[0]?.weight, ""),
        }))
        setCompetencyTypeData(data)
        setCompetencyTypeSave(data)
    }, [competencyType]);

    useEffect(() => {
        if (type !== 'edit') {
            getPreviewWorkflow(workflowList)
        }
    }, [workflowList]);

    let getPreviewWorkflow = (dataWorkflowList) => {
        let data = Util.formatData(dataWorkflowList?.workflow_data?.steps, []).map((rs) => (
            Util.formatData(rs?.action?.fields?.manager, false) !== false || Util.formatData(rs?.action?.fields?.self, false) !== false ?
                {
                    action: rs?.action?.code,
                    label: rs?.action?.label,
                    description_en: rs?.description?.en,
                    description_th: rs?.description?.th,
                    field: Util.formatData(rs?.fields, []).filter((dt) => dt?.code === "manager").length > 0 ? rs?.fields.filter((dt) => dt?.code === "manager")[0]?.id : rs?.fields[0]?.id,
                    field_status: rs?.action?.fields,
                    template_id: rs?.template_id,
                    is_send_mail: rs?.is_send_mail,
                    status: Util.formatData(rs?.action?.code === "evaluate" ? "active" : rs?.status, "inactive"),
                    step: rs?.step,
                    id: Util.formatData(rs?.id, ""),
                    tooltip_en: rs?.tooltip?.en,
                    tooltip_th: rs?.tooltip?.th,
                    startDate: Util.formatData(rs?.startDate, false) !== false ? rs.startDate.split('/')[1] + '/' + rs.startDate.split('/')[0] + '/' + rs.startDate.split('/')[2] : null,
                    endDate: Util.formatData(rs?.endDate, false) !== false ? rs.endDate.split('/')[1] + '/' + rs.endDate.split('/')[0] + '/' + rs.endDate.split('/')[2] : null,
                }
                :
                {
                    action: rs?.action?.code,
                    label: rs?.action?.label,
                    description_en: rs?.description?.en,
                    description_th: rs?.description?.th,
                    field: Util.formatData(rs?.fields[0]?.id, ""),
                    template_id: rs?.template_id,
                    is_send_mail: rs?.is_send_mail,
                    status: Util.formatData(rs?.action?.code === "evaluate" ? "active" : rs?.status, "inactive"),
                    id: Util.formatData(rs?.id, ""),
                    step: rs?.step,
                    tooltip_en: rs?.tooltip?.en,
                    tooltip_th: rs?.tooltip?.th,
                    startDate: Util.formatData(rs?.startDate, false) !== false ? rs.startDate.split('/')[1] + '/' + rs.startDate.split('/')[0] + '/' + rs.startDate.split('/')[2] : null,
                    endDate: Util.formatData(rs?.endDate, false) !== false ? rs.endDate.split('/')[1] + '/' + rs.endDate.split('/')[0] + '/' + rs.endDate.split('/')[2] : null,
                }
        ))
        setPreviewWorkflow(data)
        setPreviewWorkflowSave(data)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#D8D8D8',
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    let getTotalCommentQuestionsSave = () => {
        let competencyTypeSaveData = competencyTypeSave.filter((rs) => rs?.selected === true)
        const sum = competencyTypeSaveData.reduce((accumulator, object) => {
            return accumulator + Number(object?.weight);
        }, 0);
        return sum;
    }

    let getTotal = () => {
        let evaluateTemplateEvaluatorData = evaluateTemplateEvaluator.filter((rs) => rs?.status === "active")
        const sum = evaluateTemplateEvaluatorData.reduce((accumulator, object) => {
            return accumulator + Number(object.weight);
        }, 0);
        return sum;
    }

    let checkDisabled = (data, save) => {
        let selfDirectReportData = data.filter((rs) => rs?.status === "active" && rs?.assign_type === "self_direct_report")
        let directReportData = data.filter((rs) => rs?.status === "active" && rs?.assign_type === "direct_report")
        let selfData = data.filter((rs) => rs?.status === "active" && rs?.assign_type === "self")
        let previewWorkflowSaveData = save.map((rs) => (
            rs?.action === "submit" ?
                { ...rs, status: selfDirectReportData.length > 0 || selfData.length > 0 ? "active" : rs?.status, disabled: selfDirectReportData.length > 0 || selfData.length > 0 ? true : false }
                : rs?.action === "review" ?
                    { ...rs, status: selfDirectReportData.length > 0 || directReportData.length > 0 ? "active" : rs?.status, disabled: selfDirectReportData.length > 0 || directReportData.length > 0 ? true : false }
                    : { ...rs }
        ))
        return previewWorkflowSaveData
    }

    const changeEvaluateTemplateEvaluator = (type, index, e) => {
        let data = JSON.parse(JSON.stringify(evaluateTemplateEvaluator))
        let previewWorkflowSaveData = JSON.parse(JSON.stringify(previewWorkflowSave))
        const regex = /[^0-9]/g;
        const regexD = /[^0-9.]/g;
        if (type === "status") {
            if (data[index].status === "active") {
                data[index].weight = ""
                data[index].assign_type = ""
                data[index].display_min = ""
                data[index].assign_option = {
                    by_direct_report: {
                        min: "",
                    },
                    by_self: {
                        min: "",
                    }
                }
            }
            let WorkflowSave = checkDisabled(data, previewWorkflowSaveData)
            setPreviewWorkflowSave(WorkflowSave)
            data[index].status = data[index].status === "active" ? "inactive" : "active"
        } else if (type === "assign_type") {
            data[index].assign_type = e.target.value
            let WorkflowSave = checkDisabled(data, previewWorkflowSaveData)
            setPreviewWorkflowSave(WorkflowSave)
        } else if (type === "weight") {
            const found = e.target.value.match(regexD);
            let indexof = e.target.value.indexOf(".")
            let lastIndexof = e.target.value.lastIndexOf(".")
            let dm = (e.target.value.length - 1) - lastIndexof
            if (found !== null || isNaN(Number(e.target.value)) === true || e.target.value === "." || e.target.value === "00" || indexof !== lastIndexof) {

            } else if (indexof > 0 && indexof !== e.target.value.length - 1) {
                if (dm <= 1) {
                    data[index].weight = e.target.value
                }
            } else {
                data[index].weight = e.target.value
            }
        } else if (type === "assign_type") {
            data[index].assign_type = e.target.value
        } else if (type === "by_self" && e.target.value !== "0") {
            const found = e.target.value.match(regex);
            if (found === null && isNaN(Number(e.target.value)) === false) {
                data[index].assign_option.by_self.min = e.target.value
            }
        } else if (type === "by_direct_report" && e.target.value !== "0") {
            const found = e.target.value.match(regex);
            if (found === null && isNaN(Number(e.target.value)) === false) {
                data[index].assign_option.by_direct_report.min = e.target.value
            }
        } else if (type === "minimum" && e.target.value !== "00") {
            const found = e.target.value.match(regex);
            if (found === null && isNaN(Number(e.target.value)) === false) {
                data[index].display_min = e.target.value
            }
        }
        setEvaluateTemplateEvaluator(data)
    }

    const formikDelete = async (index) => {
        let data = JSON.parse(JSON.stringify(commentQuestionsSave))
        let dataShow = JSON.parse(JSON.stringify(commentQuestionsData))
        data.splice(index, 1)
        dataShow.splice(index, 1)
        await setCommentQuestionsData(dataShow)
        setCommentQuestionsSave(data)
    }

    const changeWorkflow = (type, index, e, fieldType) => {
        let data = JSON.parse(JSON.stringify(previewWorkflowSave))
        if (type === "status") {
            if (Util.formatData(fieldType, false) !== false) {
                if (fieldType === "manager") {
                    data[index].field_status.manager = data[index]?.field_status?.manager === "active" ? "inactive" : "active"
                } else if (fieldType === "self") {
                    data[index].field_status.self = data[index]?.field_status?.self === "active" ? "inactive" : "active"
                }
                if (data[index]?.field_status?.manager === "inactive" && data[index]?.field_status?.self === "inactive") {
                    data[index].status = "inactive"
                } else {
                    data[index].status = "active"
                }
                if (data[index].status === "inactive") {
                    data[index].startDate = null
                    data[index].endDate = null
                }
            } else {
                data[index].startDate = null
                data[index].endDate = null
                data[index].status = data[index]?.status === "active" ? "inactive" : "active"
            }
        } else if (type === "startDate") {
            if (e === null || e === "") {
                data[index].startDate = null
            } else {
                const date = Util.formatDateForJourney(dayjs(e).format('MM/DD/YYYY'))
                data[index].startDate = date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2]
            }
        } else if (type === "endDate") {
            if (e === null || e === "") {
                data[index].startDate = null
            } else {
                const date = Util.formatDateForJourney(dayjs(e).format('MM/DD/YYYY'))
                data[index].endDate = date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2]
            }
        }
        setPreviewWorkflowSave(data)
    }

    let changeStep = async (changeTo) => {
        let validateData = false
        if (changeTo === 2) {
            await setcheckStep1(true)
            // formik.touched.evaluate_journey_data?.name_en formik.touched.evaluate_journey_data?.name_th
            let previewWorkflowSaveData = previewWorkflowSave.filter((rs) => rs?.status === "active")
            let evaluateTemplateEvaluatorData = evaluateTemplateEvaluator.filter((rs) => rs?.status === "active")
            if (Util.formatData(formik?.values?.evaluate_journey_data?.name_en, false) === false || Util.formatData(formik?.values?.evaluate_journey_data?.name_th, false) === false) {
                validateData = true
            } else {
                if (previewWorkflowSaveData.length > 1) {
                    let checkData = previewWorkflowSaveData.filter((rs) => Util.formatData(rs?.startDate, false) !== false && Util.formatData(rs?.endDate, false) !== false)
                    if (checkData.length !== previewWorkflowSaveData.length) {
                        validateData = true
                    }
                } else {
                    validateData = true
                }
                if (evaluateTemplateEvaluatorData.length > 0) {
                    let filterData = evaluateTemplateEvaluatorData.filter((rs) => rs?.type !== "self")
                    let filterDataSelf = evaluateTemplateEvaluatorData.filter((rs) => rs?.type === "self")
                    console.log(filterDataSelf[0]?.weight);
                    let checkDataAppraiser = filterData.filter((rs) =>
                        Util.formatData(rs?.assign_type, false) !== false ?
                            rs?.assign_type === "self_direct_report" ?
                                Util.formatData(rs?.assign_option?.by_self?.min, false) !== false && Util.formatData(rs?.assign_option?.by_direct_report?.min, false) !== false :
                                rs?.assign_type === "direct_report" ?
                                    Util.formatData(rs?.assign_option?.by_direct_report?.min, false) !== false :
                                    rs?.assign_type === "self" ?
                                        Util.formatData(rs?.assign_option?.by_self?.min, false) !== false :
                                        false :
                            false
                    )
                    if (checkDataAppraiser.length !== filterData.length || Util.formatData(filterDataSelf[0]?.weight, false) === false) {
                        validateData = true
                    } else {
                        const sum = evaluateTemplateEvaluatorData.reduce((accumulator, object) => {
                            return accumulator + Number(object.weight);
                        }, 0);
                        if (sum === 100 || sum === "100") {

                        } else {
                            validateData = true
                        }
                    }
                } else {
                    validateData = true
                }
            }
            if (validateData === false) {
                let firstDate = previewWorkflowSaveData.sort(function (a, b) {
                    return new Date(a.startDate) - new Date(b.startDate);
                });
                let lastDate = previewWorkflowSaveData.sort(function (a, b) {
                    return new Date(a.endDate) - new Date(b.endDate);
                });
                setFirstDate(firstDate)
                setLastDate(lastDate)
            }
        } else if (changeTo === 3) {
            await setcheckStep2(true)
            if (Util.formatData(selectEvaluationComponents, false) === false || Util.formatData(decimal, false) === false) {
                validateData = true
            } else {
                let commentQuestionsSaveData = commentQuestionsSave.filter((rs) => Util.formatData(rs?.topic, false) !== false)
                let competencyTypeSaveData = competencyTypeSave.filter((rs) => rs?.selected === true && Util.formatData(rs?.weight, false) !== false)
                const sum = competencyTypeSaveData.reduce((accumulator, object) => {
                    return accumulator + Number(object?.weight);
                }, 0);
                if (commentQuestionsSaveData.length === 0 || commentQuestionsSaveData.length !== commentQuestionsSave.length) {
                    validateData = true
                } else if (selectEvaluationComponents === "custom" && Util.formatData(custom, false) === false) {
                    validateData = true
                } else if (selectEvaluationComponents === "competency" && (competencyTypeSaveData.length === 0 || sum !== 100)) {
                    validateData = true
                }
            }
        } else if (changeTo === 4) {
            await setOnSubmit(true)
            if (Util.formatData(XAxis, false) === false || Util.formatData(YAxis, false) === false || Number(YAxis) < Number(min) || Number(YAxis) > Number(max) || Number(XAxis) < Number(min) || Number(XAxis) > Number(max)) {
                validateData = true
            } else {
                let evaluateTemplateEvaluatorData = evaluateTemplateEvaluator.filter((rs) => rs?.type !== "self" && rs?.status === "active")
                let checkDisplayMin = evaluateTemplateEvaluatorData.filter((rs) => Util.formatData(rs?.display_min, false) !== false)
                if (evaluateTemplateEvaluatorData.length !== checkDisplayMin.length) {
                    validateData = true
                }
            }
        }
        if (validateData === false) {
            if (changeTo === 3) {
                await random()
                setActiveStep(changeTo)
            } else {
                setActiveStep(changeTo)
            }

        } else {
            if (Util.formatData(document.getElementsByClassName('Mui-error'), []).length > 0) {
                // setTimeout(() => {
                document.getElementsByClassName('Mui-error')[0].scrollIntoView({ behavior: "smooth", block: "center" })
                // }, 300);
            }
        }
    }

    const addDate = (date, days) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const changeCommentQuestionsData = (e, type, index) => {
        let data = JSON.parse(JSON.stringify(commentQuestionsSave))
        data[index][type] = type === "is_required" ? e : e.target.value
        setCommentQuestionsSave(data)
    }

    const changeCompetencyTypeData = (e, type, index) => {
        let data = JSON.parse(JSON.stringify(competencyTypeSave))
        if (type !== "selected") {
            const regexD = /[^0-9.]/g;
            const found = e.target.value.match(regexD);
            let indexof = e.target.value.indexOf(".")
            let lastIndexof = e.target.value.lastIndexOf(".")
            let dm = (e.target.value.length - 1) - lastIndexof
            if (found !== null || isNaN(Number(e.target.value)) === true || e.target.value === "." || e.target.value === "00" || indexof !== lastIndexof) {

            } else if (indexof > 0 && indexof !== e.target.value.length - 1) {
                if (dm <= 1) {
                    data[index][type] = e.target.value
                }
            } else {
                data[index][type] = e.target.value
            }
        } else {
            data[index][type] = e
        }
        setCompetencyTypeSave(data)
    }

    const codeAndCycleForm = () => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4}>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                <Grid container lg md xs={12}>
                    <Grid item lg={2} md={2} xs={2}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.code')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography classes={{ root: classes.textShow }} lineHeight="24px" display="flex">{code}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                <Grid container lg md xs={12}>
                    <Grid item lg={2} md={2} xs={2}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.cycle')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography classes={{ root: classes.textShow }} lineHeight="24px" display="flex">{cycleList.filter((v) => v.serial === cycle).length > 0 ? cycleList.filter((v) => v.serial === cycle)[0].name : ''}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    }

    const submitData = () => {
        let evaluateTemplateEvaluatorFilter = evaluateTemplateEvaluator.map((rs) => ({
            ...rs,
            assign_option: rs?.assign_type === "self_direct_report" ?
                rs?.assign_option :
                rs?.assign_type === "self" ?
                    { by_self: rs?.assign_option.by_self } :
                    rs?.assign_type === "direct_report" ?
                        { by_direct_report: rs?.assign_option.by_direct_report } :
                        {}
        }))
        let dataSavePreviewWorkflow = previewWorkflowSave.map((rs) => ({
            ...rs,
            startDate: Util.formatData(rs?.startDate, false) !== false ? rs.startDate.split('/')[1] + '/' + rs.startDate.split('/')[0] + '/' + rs.startDate.split('/')[2] : null,
            endDate: Util.formatData(rs?.endDate, false) !== false ? rs.endDate.split('/')[1] + '/' + rs.endDate.split('/')[0] + '/' + rs.endDate.split('/')[2] : null,
        }))
        let dataCompetencyTypeFilter = competencyTypeSave.filter((rs) => rs?.selected === true)
        let dataCompetencyTypeMap = dataCompetencyTypeFilter.map((rs) => ({ ...rs, weight: Number(rs?.weight) }))
        let requestData = {
            ...formik.values,
            code: code,
            cycle: {
                serial: cycle
            },
            status: status === true ? "active" : "inactive",
            evaluate_journey_data: {
                ...formik.values.evaluate_journey_data,
                total_score: decimal,
                serial: Util.formatData(serial, ""),
                workflow: {
                    workflow_data: {
                        code: "",
                        description: "",
                        name: "",
                        status: "active",
                        steps: dataSavePreviewWorkflow,
                        type: "360"
                    },
                },
                evaluation_component: [{
                    total: 100,
                    lists: selectEvaluationComponents === "custom" ?
                        [
                            {
                                ratio: "100",
                                allow_evaluate: true,
                                custom_form: custom,
                                require_employee_comment: false,
                                require_evaluator_comment: require_evaluator_comment
                            }
                        ]
                        :
                        [
                            {
                                ratio: "100",
                                allow_evaluate: true,
                                require_employee_comment: false,
                                require_evaluator_comment: require_evaluator_comment
                            }
                        ],
                    type: selectEvaluationComponents
                }],
                evaluate_template_result: {
                    result: {
                        x: XAxis,
                        y: YAxis
                    }
                },
                evaluate_template_question: commentQuestionsSave,
                evaluate_template_evaluator: evaluateTemplateEvaluatorFilter,
                evaluate_competency_template: {
                    name_th: "",
                    name_en: "",
                    description_th: "",
                    description_en: "",
                    competency_type: selectEvaluationComponents === "competency" ? dataCompetencyTypeMap : [],
                },
            },
        }
        if (type === 'edit') {
            adminService.updateEvaluatiionJourney(serial, requestData).then((resp) => {
                if (resp.success) {
                    openSuccessOpen(true)
                }
            })
        } else {
            adminService.createEvaluationJourney(requestData).then((resp) => {
                if (resp.success) {
                    openSuccessOpen(true)
                }
            })
        }
    }
    useEffect(() => {
        if (Util.formatData(oldData?.evaluate_journey_data, false) !== false) {
            let data = oldData?.evaluate_journey_data
            let pushData = []
            for (let index = 0; index <= evaluateTemplateEvaluator.length - 1; index++) {
                let datafilter = Util.formatData(data?.evaluate_template_evaluator, []).filter((rs) => rs?.type === evaluateTemplateEvaluator[index]?.type)
                let mergeData = {
                    ...evaluateTemplateEvaluator[index],
                    display_min: Util.formatData(datafilter[0]?.display_min, "0"),
                    assign_option: {
                        by_direct_report: {
                            min: Util.formatData(datafilter[0]?.assign_option?.by_direct_report?.min, ""),
                        },
                        by_self: {
                            min: Util.formatData(datafilter[0]?.assign_option?.by_self?.min, ""),
                        }
                    },
                    assign_type: datafilter[0]?.assign_type,
                    weight: datafilter[0]?.weight,
                    status: datafilter[0]?.weight.length > 0 ? "active" : "inactive"
                }
                pushData.push(mergeData)
            }
            setStatus(oldData?.status === "active" ? true : false)
            setEvaluateTemplateEvaluator(pushData)
            setCommentQuestionsSave(Util.formatData(data?.evaluate_template_question, ""))
            setCommentQuestionsData(Util.formatData(data?.evaluate_template_question, ""))
            setDataXAxis(Util.formatData(data?.evaluate_template_result?.result?.x, ""))
            setDataYAxis(Util.formatData(data?.evaluate_template_result?.result?.y, ""))
            setSelectEvaluationComponents(Util.formatData(data?.evaluation_component[0]?.type, ""))
            setCustom(Util.formatData(data?.evaluation_component[0]?.lists[0]?.custom_form, ""))
            setDecimal(data?.total_score)
            data.description_en = Util.formatData(data?.description_en, "")
            data.description_th = Util.formatData(data?.description_th, "")
            setRequireEvaluatorComment(Util.formatData(data?.evaluation_component[0]?.lists[0]?.require_evaluator_comment, false))
            formik.setFieldValue("evaluate_journey_data", data)
            getPreviewWorkflow(data?.workflow)
        }
    }, [oldData]);
    const evaluationTemplate = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px", ".MuiOutlinedInput-root.Mui-disabled": { borderRadius: "4px", "background-color": oldData?.is_used === true ? "#FAFAFA" : "", ".MuiInputBase-input": { color: '#404349', "background-color": "#FAFAFA", "-webkit-text-fill-color": "unset !important" }, "fieldset": { "border-color": oldData?.is_used === true ? "#FFFFFF !important" : "" } }, ".MuiFormHelperText-root.Mui-error": { color: "#CC6058" } }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ paddingTop: "14px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                        <FormGroup >
                            <FormControlLabel
                                sx={{ m: 0, color: '#404349', fontWeight: '400', fontSize: '16px', ".MuiTypography-root": { color: "#404349 !important" } }}
                                control={<IOSSwitch checked={status} disabled={oldData?.is_used === true} onChange={e => setStatus(!status)} />}
                                label={status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                            />
                        </FormGroup>
                    </Box>
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length > 100))}
                        fullWidth
                        helperText={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length > 100)) ? t('admin.inputForm.msgError.pleaseFill') : ""}
                        margin="normal"
                        name="name_en"
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "evaluate_journey_data.name_en")}
                        type="text"
                        value={formik.values.evaluate_journey_data.name_en}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_en, "").length > 100)) ? { root: classes.inputError } : { root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length > 100))}
                        helperText={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length > 100)) ? t('admin.inputForm.msgError.pleaseFill') : ""}
                        fullWidth
                        margin="normal"
                        name="name_th"
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "evaluate_journey_data.name_th")}
                        type="text"
                        value={formik.values.evaluate_journey_data.name_th}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={checkStep1 && (Boolean(Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length === 0 || Util.formatData(formik?.values?.evaluate_journey_data?.name_th, "").length > 100)) ? { root: classes.inputError } : { root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                    <TextField
                        multiline
                        fullWidth
                        minRows={2}
                        maxRows={2}
                        margin="normal"
                        name="description_en"
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "evaluate_journey_data.description_en")}
                        type="text"
                        value={formik.values.evaluate_journey_data.description_en}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                    <TextField
                        multiline
                        fullWidth
                        minRows={2}
                        maxRows={2}
                        margin="normal"
                        name="description_th"
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "evaluate_journey_data.description_th")}
                        type="text"
                        value={formik.values.evaluate_journey_data.description_th}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('label.evaluator')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ borderRadius: "10px", border: checkStep1 && (evaluateTemplateEvaluator.filter((rs) => rs?.status === "active").length <= 1 || getTotal() !== 100) ? "1px solid #CC6058" : "1px solid #CED4DA", mt: "10px", p: "30px" }}>
                        <Typography pb="20px" fontWeight="500" fontSize={16} lineHeight="24px" display="flex">{t('admin.label.selectRoleAndDetail')} <span style={{ fontWeight: "500", fontSize: "14px", lineHeight: "24px", color: "#CC6058", paddingLeft: "20px" }}>{checkStep1 && (evaluateTemplateEvaluator.filter((rs) => rs?.status === "active").length <= 1 || getTotal() !== 100) ? evaluateTemplateEvaluator.filter((rs) => rs?.status === "active").length <= 1 ? "Please select at least 1 role." : "The weight must be equal to 100." : ""}</span></Typography>
                        <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", borderTop: "1px solid #E5E5E5", background: "#FAFAFA", display: "flex" }}>
                            <Box sx={{ width: "80px" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">Select</Typography>
                            </Box>
                            <Box sx={{ width: "calc(22.35% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">Role</Typography>
                            </Box>
                            <Box sx={{ width: "calc(19.13% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">Weight</Typography>
                            </Box>
                            <Box sx={{ width: "calc(31.23% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">Appraiser Assignment Type</Typography>
                            </Box>
                            <Box sx={{ width: "calc(27.29% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">Minimum of Appraiser</Typography>
                            </Box>
                        </Box>
                        {Util.formatData(evaluateTemplateEvaluatorShow, []).map((rs, index) => (
                            <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", display: "flex" }}>
                                <Box sx={{ width: "80px", ".MuiCheckbox-colorPrimary": { ".MuiSvgIcon-root": { color: checkStep1 && evaluateTemplateEvaluator.filter((rs) => rs?.status === "active").length <= 1 ? "#CC6058" : "" }, p: "0px", margin: "0 0 0 5px" } }}>
                                    {evaluateTemplateEvaluator[index]?.type !== "self" && <Checkbox checked={evaluateTemplateEvaluator[index]?.status === "active"} disabled={oldData?.is_used === true} onClick={e => changeEvaluateTemplateEvaluator("status", index)} />}
                                </Box>
                                <Box sx={{ width: "calc(22.35% - 20px)" }}>
                                    <Typography color="#404349" fontSize={16} lineHeight="24px">{evaluateTemplateEvaluator[index]?.name}</Typography>
                                </Box>
                                <Box sx={{ width: "calc(19.13% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, pr: "20px" }}>
                                    <TextField
                                        error={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.weight, "").length === 0 && evaluateTemplateEvaluator[index]?.status === "active"}
                                        fullWidth
                                        helperText={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.weight, "").length === 0 && evaluateTemplateEvaluator[index]?.status === "active" ? t('admin.inputForm.msgError.pleaseFill') : ""}
                                        margin="normal"
                                        name="topic"
                                        onBlur={formik.handleBlur}
                                        onChange={e => changeEvaluateTemplateEvaluator("weight", index, e)}
                                        type="text"
                                        value={evaluateTemplateEvaluator[index]?.weight}
                                        variant="outlined"
                                        disabled={evaluateTemplateEvaluator[index]?.status !== "active" || oldData?.is_used === true}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            sx: {
                                                "&::placeholder": {
                                                    color: "#AAAAAA",
                                                    fontWeight: "300 !important",
                                                    opacity: "1"
                                                }
                                            }
                                        }}
                                        sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        placeholder="Fill Weight"
                                        classes={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.weight, "").length === 0 && evaluateTemplateEvaluator[index]?.status === "active" ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                    />

                                </Box>
                                {evaluateTemplateEvaluator[index]?.type !== "self" && evaluateTemplateEvaluator[index]?.status === "active" ?
                                    <Box sx={{ width: "calc(31.23% - 20px)", pr: "20px" }}>
                                        <Select
                                            variant="outlined"
                                            defaultValue=""
                                            displayEmpty
                                            size="small"
                                            fullWidth
                                            // disabled={item.edit === false ? true : false}selectError
                                            className="white-bg"
                                            onChange={e => changeEvaluateTemplateEvaluator("assign_type", index, e)}
                                            value={evaluateTemplateEvaluator[index]?.assign_type}
                                            disabled={oldData?.is_used === true}
                                            // classes={{ root: classes.select }}
                                            classes={(evaluateTemplateEvaluator[index]?.assign_type === "" || evaluateTemplateEvaluator[index]?.assign_type === null) && checkStep1 && evaluateTemplateEvaluator[index]?.status === "active" ? { root: classes.selectError } : { root: classes.select }}
                                        // onChange={selectField(`${item.key}`)}
                                        // sx={Boolean(formik.touched[item.key] && formik.errors[item.key]) ? { border: "0.5px solid red", marginTop: "10px", marginBottom: 0 } : { marginTop: "10px", marginBottom: 0 }}
                                        >
                                            <MenuItem disabled value="">
                                                <Typography variant="sub_label" style={{ fontWeight: "300 !important", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.assignmentType')}</Typography>
                                            </MenuItem>
                                            <MenuItem value="self" key="1" >
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>By Self</span>
                                            </MenuItem>
                                            <MenuItem value="direct_report" key="2" >
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>By Direct Report</span>
                                            </MenuItem>
                                            <MenuItem value="self_direct_report" key="3" >
                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px" }}>By Self and Direct Report</span>
                                            </MenuItem>
                                        </Select>
                                        {(evaluateTemplateEvaluator[index]?.assign_type === "" || evaluateTemplateEvaluator[index]?.assign_type === null) && checkStep1 && evaluateTemplateEvaluator[index]?.status === "active" ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                    </Box>
                                    :
                                    <Box sx={{ width: "calc(31.23% - 20px)", pr: "20px" }}></Box>
                                }
                                {evaluateTemplateEvaluator[index]?.type !== "self" && evaluateTemplateEvaluator[index]?.status === "active" ?
                                    <Box sx={{ width: "calc(27.29% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }}>
                                        {evaluateTemplateEvaluator[index]?.assign_type === "self" ?
                                            <TextField
                                                error={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0}
                                                fullWidth
                                                helperText={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0 ? t('admin.inputForm.msgError.pleaseFill') : ""}
                                                margin="normal"
                                                name="topic"
                                                onBlur={formik.handleBlur}
                                                onChange={e => changeEvaluateTemplateEvaluator("by_self", index, e)}
                                                type="text"
                                                value={evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min}
                                                disabled={oldData?.is_used === true}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    sx: {
                                                        "&::placeholder": {
                                                            color: "#AAAAAA",
                                                            fontWeight: "300 !important",
                                                            opacity: "1"
                                                        }
                                                    }
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder="Fill Minimum"
                                                classes={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0 ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                            />
                                            : evaluateTemplateEvaluator[index]?.assign_type === "direct_report" ?
                                                <TextField
                                                    error={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0}
                                                    fullWidth
                                                    helperText={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0 ? t('admin.inputForm.msgError.pleaseFill') : ""}
                                                    margin="normal"
                                                    name="topic"
                                                    onBlur={formik.handleBlur}
                                                    onChange={e => changeEvaluateTemplateEvaluator("by_direct_report", index, e)}
                                                    type="text"
                                                    value={evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min}
                                                    disabled={oldData?.is_used === true}
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    inputProps={{
                                                        sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA",
                                                                fontWeight: "300 !important",
                                                                opacity: "1"
                                                            }
                                                        }
                                                    }}
                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                    placeholder="Fill Minimum"
                                                    classes={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0 ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                                />
                                                : evaluateTemplateEvaluator[index]?.assign_type === "self_direct_report" ?
                                                    <Box>
                                                        <Box display="flex">
                                                            <Box width="110px">
                                                                <Typography color="#404349" fontSize={16} lineHeight="24px">Self</Typography>
                                                            </Box>
                                                            <Box width="calc(100% - 110px)">
                                                                <TextField
                                                                    error={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0}
                                                                    fullWidth
                                                                    helperText={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0 ? t('admin.inputForm.msgError.pleaseFill') : ""}
                                                                    margin="normal"
                                                                    name="topic"
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={e => changeEvaluateTemplateEvaluator("by_self", index, e)}
                                                                    type="text"
                                                                    value={evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min}
                                                                    disabled={oldData?.is_used === true}
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    inputProps={{
                                                                        sx: {
                                                                            "&::placeholder": {
                                                                                color: "#AAAAAA",
                                                                                fontWeight: "300 !important",
                                                                                opacity: "1"
                                                                            }
                                                                        }
                                                                    }}
                                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                    placeholder="Fill Minimum"
                                                                    classes={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_self?.min, "").length === 0 ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                        <Box display="flex" pt="15px">
                                                            <Box width="110px">
                                                                <Typography color="#404349" fontSize={16} lineHeight="24px">Direct Report</Typography>
                                                            </Box>
                                                            <Box width="calc(100% - 110px)">
                                                                <TextField
                                                                    error={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0}
                                                                    fullWidth
                                                                    helperText={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0 ? t('admin.inputForm.msgError.pleaseFill') : ""}
                                                                    margin="normal"
                                                                    name="topic"
                                                                    onBlur={formik.handleBlur}
                                                                    onChange={e => changeEvaluateTemplateEvaluator("by_direct_report", index, e)}
                                                                    type="text"
                                                                    value={evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min}
                                                                    disabled={oldData?.is_used === true}
                                                                    variant="outlined"
                                                                    InputLabelProps={{
                                                                        shrink: true,
                                                                    }}
                                                                    inputProps={{
                                                                        sx: {
                                                                            "&::placeholder": {
                                                                                color: "#AAAAAA",
                                                                                fontWeight: "300 !important",
                                                                                opacity: "1"
                                                                            }
                                                                        }
                                                                    }}
                                                                    sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                                    placeholder="Fill Minimum"
                                                                    classes={checkStep1 && Util.formatData(evaluateTemplateEvaluator[index]?.assign_option?.by_direct_report?.min, "").length === 0 ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                    : null}
                                    </Box>
                                    :
                                    <Box sx={{ width: "calc(27.29% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }}></Box>
                                }
                            </Box>
                        ))}
                        <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", display: "flex" }}>
                            <Box sx={{ width: "80px", ".MuiCheckbox-colorPrimary": { p: "0px", margin: "0 0 0 5px" } }}>

                            </Box>
                            <Box sx={{ width: "calc(22.35% - 20px)" }}>
                                <Typography color="#404349" fontSize={16} lineHeight="24px">Total:</Typography>
                            </Box>
                            <Box sx={{ width: "calc(19.13% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, pr: "20px" }}>
                                <Typography color={getTotal() === 0 ? "#A3A3A3" : getTotal() === 100 ? "#5DA196" : "#CC6058"} fontSize={16} lineHeight="24px">{getTotal()}</Typography>
                            </Box>
                            <Box sx={{ width: "calc(31.23% - 20px)", pr: "20px" }}>
                            </Box>
                            <Box sx={{ width: "calc(27.29% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, pr: "20px" }}>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: "flex", ".MuiCheckbox-colorPrimary": { margin: "0 20px 0 0px", p: "0px" }, pt: "25px" }}>
                        <Box>
                            <Checkbox checked={formik.values.evaluate_journey_data.hide_evaluator_to_self} disabled={oldData?.is_used === true} onClick={() => formik.setFieldValue("evaluate_journey_data.hide_evaluator_to_self", !formik.values.evaluate_journey_data.hide_evaluator_to_self)} />
                        </Box>
                        <Box>
                            <Typography fontSize={16} lineHeight="24px" color="#404349" display="flex">Hide Evaluator to Self</Typography>
                            <Typography fontSize={16} lineHeight="24px" color="#AAAAAA" fontWeight="300" display="flex">(During 360 ํ Evaluation the employee cannot view evaluators lists)</Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={12} md={12} xs={12} sx={{ pt: "0px!important" }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('label.evaluator')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ borderRadius: "10px", border: "1px solid #CED4DA", mt: "10px", p: "30px" }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" pb="20px" display="flex">{t('admin.inputForm.previewWorkflow')}</Typography>
                        <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", borderTop: "1px solid #E5E5E5", background: "#FAFAFA", display: "flex" }}>
                            <Box sx={{ width: "60px" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px"></Typography>
                            </Box>
                            <Box sx={{ width: "calc(23% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.inputForm.table.header.action')}</Typography>
                            </Box>
                            <Box sx={{ width: "calc(27% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.inputForm.table.header.description')}</Typography>
                            </Box>
                            <Box sx={{ width: "calc(50% - 20px)" }}>
                                <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.inputForm.table.header.startEndDate')}</Typography>
                            </Box>
                        </Box>
                        {Util.formatData(previewWorkflow, []).map((row, idx) => (
                            <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", display: "flex" }}>
                                <Box sx={{ width: "60px", ".MuiCheckbox-colorPrimary": { p: "0px", margin: "0 0 0 5px" } }}>
                                    {previewWorkflowSave[idx]?.action !== "evaluate" ?
                                        Object.keys(Util.formatData(previewWorkflowSave[idx]?.field_status, {})).length > 1 ?
                                            <Box width="40px">
                                                <Box>
                                                    <Checkbox checked={previewWorkflowSave[idx]?.field_status?.manager === "active"} disabled={oldData?.is_used === true} onClick={e => changeWorkflow("status", idx, e, "manager")} />
                                                </Box>
                                                <Box pt="10px">
                                                    <Checkbox checked={previewWorkflowSave[idx]?.field_status?.self === "active"} disabled={oldData?.is_used === true} onClick={e => changeWorkflow("status", idx, e, "self")} />
                                                </Box>
                                            </Box>
                                            :
                                            <Checkbox checked={previewWorkflowSave[idx]?.status === "active"} disabled={previewWorkflowSave[idx]?.disabled === true || oldData?.is_used === true} onClick={e => changeWorkflow("status", idx, e)} />
                                        : null
                                    }
                                </Box>
                                <Box sx={{ width: "calc(23% - 20px)" }}>
                                    <Box sx={Object.keys(Util.formatData(previewWorkflowSave[idx]?.field_status, {})).length > 1 ? { display: "flex" } : {}} pr="20px">
                                        <Box sx={Object.keys(Util.formatData(previewWorkflowSave[idx]?.field_status, {})).length > 1 ? { pr: "10px", width: "calc(100% - 120px)" } : {}}>
                                            <Typography classes={{ root: classes.checkboxLabel }}>
                                                {previewWorkflowSave[idx]?.label}
                                            </Typography>
                                        </Box>
                                        {Object.keys(Util.formatData(previewWorkflowSave[idx]?.field_status, {})).length > 1 ?
                                            <Box sx={{ width: "130px" }} style={{ borderLeft: '1px solid #e5e5e5', borderRight: '1px solid #e5e5e5' }}>
                                                <>
                                                    <Typography classes={{ root: classes.checkboxLabel }} style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: 5 }}>
                                                        Direct Report
                                                    </Typography>
                                                </>
                                                <>
                                                    <Typography classes={{ root: classes.checkboxLabel }} style={{ borderTop: '1px solid #e5e5e5', paddingTop: 5, paddingLeft: '10px', paddingRight: '10px' }}>
                                                        Self
                                                    </Typography>
                                                </>
                                            </Box>
                                            : null
                                        }
                                    </Box>
                                </Box>
                                <Box sx={{ width: "calc(27% - 20px)", pr: "20px" }}>
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {previewWorkflowSave[idx]?.description_th}
                                    </Typography>
                                    <Typography classes={{ root: classes.checkboxLabel }} style={{ fontSize: '14px' }}>
                                        {previewWorkflowSave[idx]?.description_en}
                                    </Typography>
                                </Box>
                                <Box sx={{ width: "calc(50% - 20px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, ".MuiIconButton-root.MuiIconButton-edgeEnd": { mr: "0px" } }}>
                                    <Box sx={{ display: "flex" }}>
                                        <Box>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} classes={{ root: classes.inputDateSize }}>
                                                <DesktopDatePicker
                                                    format="dd/MM/yyyy"
                                                    value={previewWorkflowSave[idx]?.startDate}
                                                    onChange={e => changeWorkflow("startDate", idx, e)}
                                                    disabled={oldData?.is_used === true || previewWorkflowSave[idx]?.status === "inactive"}
                                                    inputProps={{
                                                        placeholder: t("mygoal.placeholder.startDate"), sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA"
                                                            },
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        error={(previewWorkflowSave[idx]?.startDate === "" || previewWorkflowSave[idx]?.startDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active"}
                                                        classes={{ root: (previewWorkflowSave[idx]?.startDate === "" || previewWorkflowSave[idx]?.startDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active" ? classes.inputDateError : classes.inputDate }}
                                                        size="small"
                                                    />
                                                    }
                                                />
                                            </LocalizationProvider>
                                            {(previewWorkflowSave[idx]?.startDate === "" || previewWorkflowSave[idx]?.startDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active" ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseFill')} </FormHelperText>) : <></>}
                                        </Box>
                                        <Typography fontSize={14} fontWeight="500" lineHeight="21px" color="#A0A0A0" px="10px" pt="11px">
                                            -
                                        </Typography>
                                        <Box>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} classes={{ root: classes.inputDateSize }}>
                                                <DesktopDatePicker
                                                    format="dd/MM/yyyy"
                                                    value={previewWorkflowSave[idx]?.endDate}
                                                    minDate={addDate(previewWorkflowSave[idx]?.startDate, 0)}
                                                    onChange={e => changeWorkflow("endDate", idx, e)}
                                                    disabled={oldData?.is_used === true || previewWorkflowSave[idx]?.status === "inactive"}
                                                    inputProps={{
                                                        placeholder: t("mygoal.placeholder.endDate"), sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA"
                                                            }
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        error={(previewWorkflowSave[idx]?.endDate === "" || previewWorkflowSave[idx]?.endDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active"}
                                                        classes={{ root: (previewWorkflowSave[idx]?.endDate === "" || previewWorkflowSave[idx]?.endDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active" ? classes.inputDateError : classes.inputDate }}
                                                        size="small"
                                                    />
                                                    }
                                                />
                                            </LocalizationProvider>
                                            {(previewWorkflowSave[idx]?.endDate === "" || previewWorkflowSave[idx]?.endDate === null) && checkStep1 && previewWorkflowSave[idx]?.status === "active" ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseFill')} </FormHelperText>) : <></>}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{ display: "flex", ".MuiCheckbox-colorPrimary": { margin: "0 20px 0 0px", p: "0px" }, pt: "25px" }}>
                        <Box>
                            <Checkbox checked={formik.values.evaluate_journey_data.is_enforce_start} disabled={oldData?.is_used === true} onClick={() => formik.setFieldValue("evaluate_journey_data.is_enforce_start", !formik.values.evaluate_journey_data.is_enforce_start)} />
                        </Box>
                        <Box>
                            <Typography fontSize={16} lineHeight="24px" color="#404349" display="flex">Enforce Start Date</Typography>
                            <Typography fontSize={16} lineHeight="24px" color="#AAAAAA" fontWeight="300" display="flex">(If the start date has not arrived, the system will not allow to edit and submit each step of the form)</Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button color="primary" variant="contained" fullWidth onClick={e => changeStep(2)}>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        <Button color="black" variant="outlined" fullWidth onClick={changeStepTo1}>
                            {t('label.back')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper >
    }

    const showEvaluationTable = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px", ".MuiOutlinedInput-root.Mui-disabled": { borderRadius: "4px", "background-color": oldData?.is_used === true ? "#FAFAFA" : "", ".MuiInputBase-input": { color: '#404349', "background-color": "#FAFAFA", "-webkit-text-fill-color": "unset !important" }, "fieldset": { "border-color": oldData?.is_used === true ? "#FFFFFF !important" : "" } }, ".MuiFormHelperText-root.Mui-error": { color: "#CC6058" } }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationComponent')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={selectEvaluationComponents}
                        onChange={e => setSelectEvaluationComponents(e.target.value)}
                        defaultValue=""
                        displayEmpty
                        disabled={oldData?.is_used === true}
                        placeholder={t('admin.inputForm.placeholder.evaluationComponent')}
                        error={checkStep2 && Util.formatData(selectEvaluationComponents, false) === false}
                        fullWidth
                        name="evaluationType"
                        classes={checkStep2 && Util.formatData(selectEvaluationComponents, false) === false ? { root: classes.inputError } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300 !important", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.evaluationType')}</Typography>
                        </MenuItem>
                        {
                            evaluationComponents?.length > 0 ?
                                evaluationComponents.map(item => {
                                    return (
                                        <MenuItem value={item?.type} key={item?.type}>
                                            {item?.type === "custom" ? t('admin.label.customFormTemplate') : item?.type === "competency" ? t('admin.inputForm.competency') : ""}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {checkStep2 && Util.formatData(selectEvaluationComponents, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.scoreDecimal')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={decimal}
                        onChange={e => setDecimal(e.target.value)}
                        defaultValue=""
                        displayEmpty
                        disabled={oldData?.is_used === true}
                        placeholder={t('admin.inputForm.placeholder.scoreDecimal')}
                        error={checkStep2 && Util.formatData(decimal, false) === false}
                        fullWidth
                        name="scoreDecimal"
                        classes={checkStep2 && Util.formatData(decimal, false) === false ? { root: classes.inputError } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300 !important", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.scoreDecimal')}</Typography>
                        </MenuItem>
                        {
                            scoreDecimal?.length > 0 ?
                                scoreDecimal.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.code}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {checkStep2 && Util.formatData(decimal, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {selectEvaluationComponents === "custom" ?
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.label.customFormTemplate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Select
                            id="workload-select"
                            inputlabelprops={{ shrink: false }}
                            variant="outlined"
                            size="small"
                            onChange={e => setCustom(e.target.value)}
                            value={custom}
                            defaultValue=""
                            displayEmpty
                            placeholder={t('admin.inputForm.placeholder.evaluationType')}
                            error={checkStep2 && Util.formatData(custom, false) === false}
                            disabled={oldData?.is_used === true}
                            fullWidth
                            name="evaluationType"
                            classes={checkStep2 && Util.formatData(custom, false) === false ? { root: classes.inputError } : { root: classes.input }}
                            sx={{ marginBottom: 0, marginTop: '16px' }}
                        >
                            <MenuItem disabled value="">
                                <Typography variant="sub_label" style={{ fontWeight: "300 !important", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.customForm')}</Typography>
                            </MenuItem>
                            {
                                Util.formatData(customFormList, [])?.length > 0 ?
                                    customFormList.map(item => {
                                        return (
                                            <MenuItem value={item.serial} key={item.serial}>
                                                {item.name}
                                            </MenuItem>
                                        )
                                    })

                                    : <MenuItem value="">
                                        ---{t('label.notFund')}---
                                    </MenuItem>
                            }
                        </Select>
                        {checkStep2 && Util.formatData(custom, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                    </Grid>
                    <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    </Grid>
                </Grid>
                : selectEvaluationComponents === "competency" ?
                    <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", }}>
                            <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.label.competencyType')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                            <Box sx={{ borderRadius: "10px", border: checkStep2 === true ? competencyTypeSave.filter((rs) => rs?.selected === true).length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", mt: "10px", p: "30px" }}>
                                <Typography pb="20px" fontWeight="500" fontSize={16} lineHeight="24px" display="flex">{t('admin.inputForm.manageQuestion')}</Typography>
                                <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", borderTop: "1px solid #E5E5E5", background: "#FAFAFA", display: "flex" }}>
                                    <Box sx={{ width: "80px" }}>
                                        <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.inputForm.table.header.select')}</Typography>
                                    </Box>
                                    <Box sx={{ width: "calc(25% - 40px)" }}>
                                        <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.label.topic')}</Typography>
                                    </Box>
                                    <Box sx={{ width: "calc(75% - 40px)" }}>
                                        <Typography fontWeight="500" color="#A0A0A0" fontSize={14} lineHeight="20.93px">{t('admin.inputForm.ratio')} (%)</Typography>
                                    </Box>
                                </Box>
                                {Util.formatData(competencyTypeData, []).map((rs, index) => (
                                    <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", display: "flex" }}>
                                        <Box sx={{ width: "80px", ".MuiCheckbox-colorPrimary": { p: "0px", margin: "0 0 0 5px" } }}>
                                            <Checkbox checked={competencyTypeSave[index]?.selected === true} disabled={oldData?.is_used === true} onClick={e => changeCompetencyTypeData(!competencyTypeSave[index]?.selected, "selected", index)} />
                                        </Box>
                                        <Box sx={{ width: "calc(25% - 40px)" }}>
                                            <Typography color="#404349" fontSize={16} lineHeight="24px">{rs?.name}</Typography>
                                        </Box>
                                        <Box sx={{ width: "calc(75% - 40px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, pr: "20px" }}>
                                            <TextField
                                                error={checkStep2 && competencyTypeSave[index]?.selected === true && Util.formatData(competencyTypeSave[index]?.weight, false) === false}
                                                fullWidth
                                                // helperText={formik.touched.name && formik.errors.name}
                                                margin="normal"
                                                name="topic"
                                                onBlur={formik.handleBlur}
                                                onChange={e => changeCompetencyTypeData(e, "weight", index)}
                                                type="text"
                                                value={competencyTypeSave[index]?.weight}
                                                disabled={oldData?.is_used === true}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                inputProps={{
                                                    sx: {
                                                        "&::placeholder": {
                                                            color: "#AAAAAA",
                                                            fontWeight: "300 !important",
                                                            opacity: "1"
                                                        }
                                                    }
                                                }}
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                                placeholder="Fill Weight"
                                                classes={checkStep2 && competencyTypeSave[index]?.selected === true && Util.formatData(competencyTypeSave[index]?.weight, false) === false ? { root: classes.inputTopicError } : { root: classes.inputTopic }}
                                            />
                                            {checkStep2 && competencyTypeSave[index]?.selected === true && Util.formatData(competencyTypeSave[index]?.weight, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                        </Box>
                                    </Box>
                                ))}
                                <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", display: "flex" }}>
                                    <Box sx={{ width: "80px", ".MuiCheckbox-colorPrimary": { p: "0px", margin: "0 0 0 5px" } }}>

                                    </Box>
                                    <Box sx={{ width: "calc(25% - 40px)" }}>
                                    </Box>
                                    <Box sx={{ width: "calc(75% - 40px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, pr: "20px", display: "flex", justifyContent: "space-between" }}>
                                        <Typography color="#404349" fontSize={16} lineHeight="24px">Total:</Typography>
                                        <Typography color={getTotalCommentQuestionsSave() === 0 ? "#A3A3A3" : getTotalCommentQuestionsSave() === 100 ? "#5DA196" : "#CC6058"} fontSize={16} lineHeight="24px">{getTotalCommentQuestionsSave()}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    : null
            }
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", }}>
                    <Box sx={{ display: "flex", ".MuiCheckbox-colorPrimary": { margin: "0 20px 0 0px", p: "0px" }, pb: "25px" }}>
                        <Box>
                            <Checkbox checked={require_evaluator_comment} disabled={oldData?.is_used === true} onClick={() => setRequireEvaluatorComment(!require_evaluator_comment)} />
                        </Box>
                        <Box>
                            <Typography fontSize={16} lineHeight="24px" color="#404349" display="flex">Require comment per item</Typography>
                        </Box>
                    </Box>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.label.commentQuestions')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ borderRadius: "10px", border: checkStep2 === true ? commentQuestionsData.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", mt: "10px", p: "30px" }}>
                        <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between", pb: "10px" }}>
                            <Typography fontWeight="500" fontSize={16} lineHeight="24px" display="flex">{t('admin.inputForm.manageQuestion')}</Typography>
                            <Box onClick={e => oldData?.is_used === true ? null : addQuestion()} sx={{ cursor: oldData?.is_used === true ? "" : "pointer", width: "max-content", display: "flex", "flex-direction": "row", "justify-content": "center", "align-items": "center", padding: "4px 10px", "border-radius": "4px", }}>
                                <Plus />
                                <Typography pl="5px" fontWeight="500" color="#5DA196" fontSize={18} lineHeight="26.91px" display="flex">
                                    {/* {t('label.add')} */}
                                    Add
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ p: "20px 30px", borderBottom: "1px solid #E5E5E5", borderTop: "1px solid #E5E5E5", background: "#FAFAFA", display: "flex" }}>
                            <Divider />
                            <Box sx={{ height: "48px", width: "100%", display: "flex", "align-items": "center" }}>
                                <Box sx={{ width: "calc(100% - 140px)" }}>
                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.topic')}</Typography>
                                </Box>
                                <Box sx={{ width: "80px" }}>
                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.required')}</Typography>
                                </Box>
                                <Box sx={{ width: "60px" }}>
                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">{t('admin.label.action')}</Typography>
                                </Box>
                            </Box>
                            <Divider />
                        </Box>
                        {Util.formatData(commentQuestionsData, []).map((rs, index) => (
                            <Box sx={{ padding: "0 25px" }}>
                                <Box sx={{ display: "flex", }}>
                                    <Box sx={{ width: "calc(100% - 140px)", '.MuiOutlinedInput-root': { "padding": "0px !important" }, }} py="10px" pr="40px">
                                        <TextField
                                            error={checkStep2 && Util.formatData(commentQuestionsSave[index]?.topic, false) === false}
                                            fullWidth
                                            // helperText={formik.touched.name && formik.errors.name}
                                            margin="normal"
                                            name="topic"
                                            onChange={e => changeCommentQuestionsData(e, "topic", index)}
                                            type="text"
                                            value={commentQuestionsSave[index]?.topic}
                                            disabled={oldData?.is_used === true}
                                            multiline
                                            minRows={2}
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                sx: {
                                                    "&::placeholder": {
                                                        color: "#AAAAAA",
                                                        fontWeight: "300 !important",
                                                        opacity: "1"
                                                    }
                                                }
                                            }}
                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                            placeholder={t('admin.inputForm.placeholder.fillTheTopic')}
                                            classes={checkStep2 && Util.formatData(commentQuestionsSave[index]?.topic, false) === false ? { root: classes.inputTopicErroTextarear } : { root: classes.inputTopicTextarea }}
                                        />
                                        {checkStep2 && Util.formatData(commentQuestionsSave[index]?.topic, false) === false ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                    </Box>
                                    <Box pl="15px" sx={{ width: "80px", ".MuiCheckbox-colorPrimary": { p: "0px", margin: "0" } }} py="11.5px">
                                        <Checkbox checked={commentQuestionsSave[index]?.is_required} disabled={oldData?.is_used === true} onClick={e => changeCommentQuestionsData(commentQuestionsSave[index]?.is_required === false ? true : false, "is_required", index)} />
                                    </Box>
                                    <Box sx={{ width: "60px", "padding-left": "10px", height: "20px" }} my="14.5px">
                                        {oldData?.is_used === true || commentQuestionsSave.length === 1 ?
                                            <Delete style={{ cursor: "default" }} className={classes.fillGrey} />
                                            :
                                            <Delete style={{ cursor: "pointer" }} onClick={e => formikDelete(index)} />
                                        }
                                    </Box>
                                </Box>
                                <Divider />
                            </Box>
                        ))}
                    </Box>
                </Grid>
            </Grid>
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button color="primary" variant="contained" fullWidth onClick={e => changeStep(3)}>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        <Button color="black" variant="outlined" fullWidth onClick={e => setActiveStep(1)}>
                            {t('label.back')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const summaryForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 0px 0px" }} />
                </Grid>
            </Grid>
            {showSummary(previewWorkflowSave)}
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        <Button color="primary" variant="contained" fullWidth onClick={submitData}>
                            {type === 'edit' ? t('label.save') : t(`label.create`)}
                        </Button>
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        <Button color="black" variant="outlined" fullWidth onClick={e => setActiveStep(3)}>
                            {t('label.back')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const showSummary = (dataShow) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'15px'}>
            <Grid item lg={12} md={12} xs={12} classes={{ root: classes.summaryTable }}>
                <Box sx={{ background: "#FAFAFA", display: "flex", alignItems: "center", height: "50px", borderBottom: "1px solid #E5E5E5" }}>
                    <Typography width="57.03%" pl="20px" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        Template Name
                    </Typography>
                    <Typography width="21.26%" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        Start Date
                    </Typography>
                    <Typography width="21.71%" pr="20px" color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
                        End Date
                    </Typography>
                </Box>
                <Box sx={{ overflowY: "overlay", }}>
                    {Util.formatData(previewWorkflowSave, []).length > 0 ?
                        <Summary360 start={Util.dateDayFormatAdmin(firstDates[0].startDate)} last={Util.dateDayFormatAdmin(lastDates[lastDates.length - 1].endDate)} data={previewWorkflowSave} name={cycleList.filter((v) => v.serial === cycle).length > 0 ? cycleList.filter((v) => v.serial === cycle)[0].name : ''} />
                        : null
                    }
                </Box>
            </Grid>
        </Grid>
    }

    const formikChangeAxis = (val, field,) => {
        const regexD = /[^0-9.]/g;
        const found = val.target.value.match(regexD);
        let indexof = val.target.value.indexOf(".")
        let lastIndexof = val.target.value.lastIndexOf(".")
        let dm = (val.target.value.length - 1) - lastIndexof
        if (found !== null || isNaN(Number(val.target.value)) === true || val.target.value === "." || val.target.value === "00" || indexof !== lastIndexof) {
        } else if (indexof > 0 && indexof !== val.target.value.length - 1) {
            if (dm <= 1) {
                if (field === "XAxis") {
                    setDataXAxis(val.target.value)
                } else {
                    setDataYAxis(val.target.value)
                }
            }
        } else {
            if (field === "XAxis") {
                setDataXAxis(val.target.value)
            } else {
                setDataYAxis(val.target.value)
            }
        }
    }

    const scatterOptions = {
        grid: {
            // width: "auto",
            left: 60
        },
        color: colorsPallet,
        tooltip: {
            show: true
        },
        legend: {
            show: false,
        },
        xAxis: [
            {
                position: "bottom",
                min: 0,
                max: 5,
                axisTick: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                position: "left",
                min: 0,
                max: 5,
                axisTick: {
                    show: false
                }
            }
        ],
        series: [
            {
                name: "series 1",
                symbolSize: 12,
                data: [
                    {
                        value: [5.0, 1.04]
                    }
                ],
                type: 'scatter',
            },
            {
                name: "series 2",
                symbolSize: 12,
                data: [
                    {
                        value: [1.07, 4.95]
                    }
                ],
                type: "scatter"
            },
            {
                name: "series 3",
                symbolSize: 12,
                data: [
                    {
                        value: [2.07, 1.95]
                    }
                ],
                type: "scatter"
            },
            {
                name: "series 4",
                symbolSize: 12,
                data: [
                    {
                        value: [4.07, 3.95]
                    }
                ],
                type: "scatter"
            },
            {
                name: "series 5",
                symbolSize: 12,
                data: [
                    {
                        value: [2.85, 2.7]
                    }
                ],
                type: "scatter"
            },
            // chart's border
            {
                ignore: true,
                type: 'line',
                markLine: {
                    silent: true,
                    lineStyle: {
                        type: 'solid',
                        color: "#404349",
                    },
                    data: [
                        [
                            {
                                coord: [0, 5],
                                symbol: 'none'
                            },
                            {
                                coord: [5, 5],
                                symbol: 'none'
                            }
                        ],
                        [
                            {
                                coord: [5, 5],
                                symbol: 'none'
                            },
                            {
                                coord: [5, 0],
                                symbol: 'none'
                            }
                        ]
                    ]
                }
            },
            {
                ignore: true,
                type: "line",
                markLine: {
                    silent: true,
                    lineStyle: {
                        type: 'solid',
                        color: "#404349",
                        width: 2
                    },
                    data: [
                        [
                            {
                                coord: [0, 3.5],
                                symbol: 'none'
                            },
                            {
                                coord: [5, 3.5],
                                symbol: 'none'
                            }
                        ],
                        [
                            {
                                coord: [3.5, 5],
                                symbol: 'none'
                            },
                            {
                                coord: [3.5, 0],
                                symbol: 'none'
                            }
                        ]
                    ]
                }
            }
        ]
    }
    const [scatterChartType, setScatterChartType] = React.useState("rating")
    const [colorBar, setColor] = React.useState(colorsPallet)
    const [eachItemChartType, setEachItemChartType] = React.useState([])
    const [scatterChartOptions, setScatterChartOptions] = React.useState(scatterOptions)
    const [scatterChartWidth, setScatterChartWidth] = React.useState(0)
    const sortOrder = ["self", "others", "superior", "subordinate", "peer"]
    const dataCategory = ["Category#1", "Category#2", "Category#3"]
    const [overviewData, setOverviewData] = React.useState({})
    const [dataResult, setDataResult] = React.useState({ x: 0, y: 0 })
    const [XAxis, setDataXAxis] = React.useState("")
    const [YAxis, setDataYAxis] = React.useState("")
    const [min, setMin] = React.useState(0)
    const [max, setMax] = React.useState(5)
    const [dataSets, setDataSets] = React.useState([])
    useEffect(() => {
        if (dataSets.length > 0) {
            handleScatterChart()
        }
    }, [dataSets])
    function randomIntFromInterval(min, max) { // min and max included 
        return (Math.random() * (max - min)) + min;
    }

    useEffect(() => {
        if (Number(XAxis) <= Number(max) && Number(YAxis) <= Number(max)) {
            let data = {}
            data = { x: Number(XAxis), y: Number(YAxis) }
            setDataResult(data)
        }
    }, [XAxis, YAxis]);

    useEffect(() => {
        handleScatterChart()
    }, [dataResult]);

    const random = () => {
        var arr = [];
        for (let i = 0; i < 3; i++) {
            let valueOthers = randomIntFromInterval(Number(min), Number(max))
            let valuePeer = randomIntFromInterval(Number(min), Number(max))
            let valueSelf = randomIntFromInterval(Number(min), Number(max))
            let valueSubordinate = randomIntFromInterval(Number(min), Number(max))
            let valueSuperior = randomIntFromInterval(Number(min), Number(max))
            arr.push({
                value: {
                    options: {
                        others: valueOthers,
                        peer: valuePeer,
                        self: valueSelf,
                        subordinate: valueSubordinate,
                        superior: valueSuperior,
                    },
                    others: valueOthers,
                    self: valueSelf
                }
            })
        }
        setDataSets(arr)
    }

    // set scatter chart width
    const scatterChartRefCallback = useCallback((node) => {
        if (node) {
            setScatterChartWidth(node?.offsetWidth ?? 0)
        }
    }, [])
    useEffect(() => {
        let tmpScatterChartOptions = JSON.parse(JSON.stringify(scatterChartOptions))
        let updatedScatterChart = {
            ...tmpScatterChartOptions,
            grid: {
                ...tmpScatterChartOptions.grid,
                width: scatterChartWidth - 70
            },
        }
        setScatterChartOptions(updatedScatterChart)
    }, [scatterChartWidth])

    const handleScatterChart = () => {
        let tmpScatterChartOptions = JSON.parse(JSON.stringify(scatterChartOptions))
        let scatterDataSets = []
        let scatterLabels = JSON.parse(JSON.stringify(dataCategory))
        let scatterResult = JSON.parse(JSON.stringify(dataResult))
        let tmpScatterDataSets = JSON.parse(JSON.stringify(dataSets))
        tmpScatterDataSets.sort((a, b) => {
            return sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label)
        })
        let tmpValues = {}
        let optionsValues = {}
        tmpScatterDataSets.forEach((item, index) => {
            tmpValues = {
                value: [item?.value?.others ?? 0, item?.value?.self ?? 0],
                options: item?.value?.options,
            }
            if (tmpValues?.options) {
                optionsValues = tmpValues.options
            }
            const sortedOptionsValues = {}
            sortOrder.forEach(key => {
                if (optionsValues.hasOwnProperty(key)) {
                    sortedOptionsValues[key] = optionsValues[key]
                }
            })
            scatterDataSets.push({
                name: scatterLabels[index],
                symbolSize: 12,
                data: [
                    {
                        value: tmpValues.value
                    }
                ],
                type: 'scatter',
                tooltip: {
                    padding: 0,
                    borderWidth: 0,
                    extraCssText: 'box-shadow: none;',
                    show: true,
                    formatter: (params) => {
                        let result = `<div style="display: inline-block; width: 220px; border-radius: 3px; overflow: hidden; box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15); font-family: Kanit;">
                        <div style="width: 100%; background-color: #67A79D; height: 35px; color: #FFF; padding: 8px;">
                            <span style="width: 70%; color: #FFF; font-size: 16px; font-weight: 400;">${params?.seriesName}</span>
                        </div>
                        <div style="width: 100%; background-color: #F7F7F7; padding: 8px; display: flex; flex-direction: column;">`
                        for (const [key, value] of Object.entries(sortedOptionsValues ?? {})) {
                            result += `<div style="width: 100%; display: flex">`
                            if (key === "self") {
                                result += `<span style="width: 70%; color: #404349; font-size: 16px; font-weight: 400;">${Util.capitalizedString(key)}:</span>`
                            } else if (key === "others") {
                                result += `<span style="width: 70%; color: #404349; font-size: 16px; font-weight: 400;">${Util.capitalizedString(key)}:</span>`
                            } else {
                                result += `<span style="width: 70%; color: #404349; font-size: 16px; font-weight: 400; padding-left: 15px;"> • ${Util.capitalizedString(key)}:</span>`
                            }
                            result += `<span style="width: 30%; color: #404349; font-size: 16px; font-weight: 400; text-align: right">${value}${scatterChartType === "percentage" ? "%" : ""}</span>
                                </div>`
                        }
                        result += `</div></div>`
                        return result
                    }
                }
            })
        })

        let scatterResultCrossLine = {
            x: scatterChartType === "rating" ? scatterResult?.x ?? 0 : parseFloat(scatterResult?.x ?? 0) / parseFloat(overviewData.scatter_chart?.max) * 100,
            y: scatterChartType === "rating" ? scatterResult?.y ?? 0 : parseFloat(scatterResult?.y ?? 0) / parseFloat(overviewData.scatter_chart?.max) * 100
        }
        tmpScatterChartOptions = {
            ...tmpScatterChartOptions,
            xAxis: [
                {
                    position: "bottom",
                    min: min,
                    max: max,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontFamily: "Kanit",
                        formatter: (e) => {
                            return `${e}${scatterChartType === "percentage" ? "%" : ""}`
                        }
                    }
                }
            ],
            yAxis: [
                {
                    position: "left",
                    min: min,
                    max: max,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        fontFamily: "Kanit",
                        formatter: (e) => {
                            return `${e}${scatterChartType === "percentage" ? "%" : ""}`
                        }
                    }
                }
            ],
            series: [
                // real data
                ...scatterDataSets,
                // chart's border
                {
                    ignore: true,
                    type: 'line',
                    markLine: {
                        silent: true,
                        lineStyle: {
                            type: 'solid',
                            color: "#404349",
                        },
                        data: [
                            [
                                {
                                    coord: [min, scatterChartType === "rating" ? max : 100],
                                    symbol: 'none'
                                },
                                {
                                    coord: scatterChartType === "rating" ? [max, max] : [100, 100],
                                    symbol: 'none'
                                }
                            ],
                            [
                                {
                                    coord: scatterChartType === "rating" ? [max, max] : [100, 100],
                                    symbol: 'none'
                                },
                                {
                                    coord: [scatterChartType === "rating" ? max : 100, min],
                                    symbol: 'none'
                                }
                            ]
                        ]
                    }
                },
                // cross line value
                {
                    ignore: true,
                    type: "line",
                    id: "line-scatter",
                    markLine: {
                        silent: true,
                        lineStyle: {
                            type: 'solid',
                            color: "#404349",
                            width: 2
                        },
                        data: [
                            [
                                {
                                    coord: [min, scatterResultCrossLine.x],
                                    symbol: 'none',
                                    label: {
                                        formatter: `(${scatterResultCrossLine.x}${scatterChartType === "percentage" ? "%" : ""})`,
                                        position: "insideStartTop",
                                        distance: [2, 5],
                                        color: "#AAAAAA",
                                        fontSize: 13,
                                        fontFamily: "Kanit"
                                    }
                                },
                                {
                                    coord: [max, scatterResultCrossLine.x],
                                    symbol: 'none',
                                }
                            ],
                            [
                                {
                                    coord: [scatterResultCrossLine.y, max],
                                    symbol: 'none',
                                    label: {
                                        formatter: `(${scatterResultCrossLine.y}${scatterChartType === "percentage" ? "%" : ""})`,
                                        position: "insideEndTop",
                                        rotate: 360,
                                        distance: [2, 2],
                                        color: "#AAAAAA",
                                        fontSize: 13,
                                        fontFamily: "Kanit"
                                    }
                                },
                                {
                                    coord: [scatterResultCrossLine.y, min],
                                    symbol: 'none',
                                }
                            ]
                        ]
                    }
                },

            ]
        }
        setScatterChartOptions(tmpScatterChartOptions)
    }

    const BarLegend = (props) => {
        const { data, colors, type } = props
        let row = []
        const { t } = useTranslation()
        const filterData = type === "radar" ? data?.series?.data : data?.series?.filter(item => !item?.ignore)

        const [legendActiveStatus, setLegendActiveStatus] = React.useState([])

        const handleToggleLegend = (data, index) => {
            let tmpStatus = [...legendActiveStatus]
            tmpStatus[index] = !tmpStatus[index]
            setLegendActiveStatus(tmpStatus)
            props.toggleLegend(data)
        }

        const getRadarName = (index) => {
            if (filterData?.[index]?.name?.toLowerCase() === "self" || filterData?.[index]?.name?.toLowerCase() === "ตนเอง") {
                return `${filterData?.[index]?.name}`
            } else {
                return `${filterData?.[index]?.name} (${filterData?.[index]?.count ?? "-"})`
            }
        }

        filterData.forEach((item, i) => {
            row.push(
                <Box key={item.name} sx={{ display: "flex", alignItems: "center", px: 2, cursor: type === "radar" ? "pointer" : "default" }} onClick={() => type === "radar" ? handleToggleLegend(item, i) : ""}>
                    <Box sx={{ width: "10px", mr: 1 }}>
                        <div className="bar-legend-circle" style={{ backgroundColor: colors[i] }}></div>
                    </Box>
                    <Box sx={{ width: "auto", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }} px="2.5px"><Typography style={styles.barLegend} color={type !== "radar" ? "#404349" : legendActiveStatus?.[i] ? "#404349" : "#A0A0A0"}> {type === "radar" ? getRadarName(i) : item.name}</Typography></Box>
                </Box>
            )
        })

        useEffect(() => {
            let status = []
            filterData.forEach((item, i) => {
                status.push(true)
            })
            setLegendActiveStatus(status)
        }, [])
        return (row)
    }

    const evaluationTemplateStep2 = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px", ".MuiOutlinedInput-root.Mui-disabled": { borderRadius: "4px", "background-color": oldData?.is_used === true ? "#FAFAFA" : "", ".MuiInputBase-input": { color: '#404349', "background-color": "#FAFAFA", "-webkit-text-fill-color": "unset !important" }, "fieldset": { "border-color": oldData?.is_used === true ? "#FFFFFF !important" : "" } }, ".MuiFormHelperText-root.Mui-error": { color: "#CC6058" } }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'} >
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", }}>
                    {/* <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography> */}
                    {/* <Box sx={{ width: "calc(100% - 80px)", margin: "0 40px" }} pt="20px" > */}
                    <Typography variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Minimum evaluators to display group score <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ position: "relative" }}>
                        <Box mt="10px" sx={{ border: onSubmit === true ? evaluateTemplateEvaluatorShow.length === 0 ? "1px solid #CC6058" : "1px solid #CED4DA" : "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px", padding: "17px 29px" }}>
                            <Box sx={{ display: "flex", "align-items": "center", "justify-content": "space-between" }}>
                                <Typography sx={{ textTransform: "uppercase" }} fontWeight="500" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">manage display group score  </Typography>
                            </Box>
                            <Box sx={{ overflow: "hidden", height: "100%", transition: "all .8s", "max-height": evaluateTemplateEvaluatorShow !== undefined && evaluateTemplateEvaluatorShow !== null && evaluateTemplateEvaluatorShow.length > 0 ? "999999px" : "0px" }}>
                                {evaluateTemplateEvaluatorShow !== undefined && evaluateTemplateEvaluatorShow !== null && evaluateTemplateEvaluatorShow.length > 0 ?
                                    <Box pb="16px">
                                        <Box sx={{ width: "100%", background: "#FAFAFA", }} mt="16px">
                                            <Divider />
                                            <Box sx={{ height: "50px", padding: "0 25px", display: "flex", "align-items": "center" }}>

                                                <Box sx={{ width: "20%" }} pr="40px">
                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Group Score</Typography>
                                                </Box>
                                                <Box sx={{ width: "80%" }} pr="40px">
                                                    <Typography color="#A0A0A0" fontWeight="500" fontSize={14} lineHeight="20.93px" display="flex">Minimum Evaluators to Display Group Score</Typography>
                                                </Box>

                                            </Box>
                                            <Divider />
                                        </Box>
                                        {evaluateTemplateEvaluatorShow.map((item, idx) => evaluateTemplateEvaluator[idx]?.type !== "self" && evaluateTemplateEvaluator[idx]?.status === "active" ? (
                                            <Box sx={{ width: "100%" }} >
                                                <Box sx={{ minHeight: "60px", height: "calc(100% - 20px)", padding: "0 25px", display: "flex", "align-items": "center", position: "relative" }}>
                                                    <Box sx={{ width: "20%" }} pr="40px">
                                                        <Typography fontWeight="400" color="#404349" fontSize={16} lineHeight="23.92px" display="flex">{evaluateTemplateEvaluator[idx]?.name}</Typography>
                                                    </Box>
                                                    <Box sx={{ width: "80%", ".MuiTextField-root": { "margin": "0px !important" }, ".MuiFormHelperText-root": { marginTop: "3px" } }} py="15px" pr="15px">
                                                        <TextField
                                                            error={onSubmit ? Util.formatData(evaluateTemplateEvaluator[idx]?.display_min, false) === false : false}
                                                            fullWidth
                                                            margin="normal"
                                                            name={"minimum"}
                                                            onChange={e => changeEvaluateTemplateEvaluator("minimum", idx, e)}
                                                            type="text"
                                                            disabled={oldData?.is_used === true}
                                                            value={evaluateTemplateEvaluator[idx]?.display_min}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                                                            placeholder={"Fill number"}
                                                            classes={onSubmit && Util.formatData(evaluateTemplateEvaluator[idx]?.display_min, false) === false ? { root: classes.inputError } : { root: classes.input }}
                                                        />
                                                        {onSubmit ? Util.formatData(evaluateTemplateEvaluator[idx]?.display_min, false) === false ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : <></> : <></>}
                                                    </Box>
                                                </Box>
                                                <Divider />
                                            </Box>
                                        )
                                            : null
                                        )
                                        }
                                    </Box>
                                    :
                                    null
                                }
                            </Box>
                        </Box>
                        {/* {onSubmit === true ? ratingScale.length > 0 ? ratingScale.length > 0 && checkDataOne(formik.values.ratingScale) === false ?
                                <Typography fontWeight="400" color="#d32f2f" fontSize="0.75rem" lineHeight="1.66" sx={{ position: "absolute", "margin-top": "3px", "margin-right": "14px", "margin-bottom": "0", "margin-left": "14px" }}>{t('admin.inputForm.msgError.nameEN')}</Typography>
                                : null : null : null} */}
                    </Box>
                    {/* </Box> */}
                </Grid>
            </Grid>
            <Typography mt="25px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Set Up Standard Line for Chart</Typography>
            <Grid container lg md xs={12} display="flex" mt={'10px'} spacing={4} >
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">X Axis <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                        <Typography fontSize="14px" fontWeight="400" color="#404349">{`Min:${min}, Max:${max}`}</Typography>
                    </Box>
                    <TextField
                        error={onSubmit ? Util.formatData(XAxis, false) === false || Number(XAxis) < Number(min) || Number(XAxis) > Number(max) : false}
                        fullWidth
                        // helperText={formik.touched.XAxis && formik.errors.XAxis}
                        margin="normal"
                        name="XAxis"
                        onBlur={formik.handleBlur}
                        onChange={e => formikChangeAxis(e, "XAxis")}
                        disabled={oldData?.is_used === true}
                        type="text"
                        value={XAxis}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder="Fill the Rating"
                        classes={onSubmit ? Util.formatData(XAxis, false) === false ? { root: classes.inputError } : { root: classes.input } : { root: classes.input }}
                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                    />
                    {onSubmit ? Util.formatData(XAxis, false) === false || Number(XAxis) < Number(min) || Number(XAxis) > Number(max) ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : Number(XAxis) < Number(min) || Number(XAxis) > Number(max) ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginLeft: "14px" }}>Please fill rating between min and max. </FormHelperText>) : <></> : <></>}
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography variant="subtitle1" fontWeight="500" color="#404349" fontSize={18} lineHeight="24px" display="flex">Y Axis <span style={{ marginLeft: "5px", color: "#CC6058 " }}> *</span></Typography>
                        <Typography fontSize="14px" fontWeight="400" color="#404349">{`Min:${min}, Max:${max}`}</Typography>
                    </Box>
                    <TextField
                        error={onSubmit ? Util.formatData(YAxis, false) === false || Number(YAxis) < Number(min) || Number(YAxis) > Number(max) : false}
                        fullWidth
                        // helperText={formik.touched.YAxis && formik.errors.YAxis}
                        margin="normal"
                        name="YAxis"
                        onChange={e => formikChangeAxis(e, "YAxis")}
                        disabled={oldData?.is_used === true}
                        type="text"
                        value={YAxis}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder="Fill the Rating"
                        classes={onSubmit ? Util.formatData(YAxis, false) === false || Number(YAxis) < Number(min) || Number(YAxis) > Number(max) ? { root: classes.inputError } : { root: classes.input } : { root: classes.input }}
                        sx={{ ".MuiOutlinedInput-root": { color: "#404349" } }}
                    />
                    {onSubmit ? Util.formatData(YAxis, false) === false || Number(YAxis) < Number(min) || Number(YAxis) > Number(max) ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginLeft: "14px" }}>{t('admin.inputForm.msgError.nameTH')} </FormHelperText>) : Number(YAxis) < Number(min) || Number(YAxis) > Number(max) ? (<FormHelperText error sx={{ marginTop: "-5px", marginRight: "14px", marginLeft: "14px" }}>Please fill rating between min and max. </FormHelperText>) : <></> : <></>}
                </Grid>
            </Grid>
            <Typography mt="25px" variant="subtitle1" color="#404349" fontWeight="500" fontSize={18} lineHeight="26.91px" display="flex">Result Preview</Typography>
            <Grid container lg md xs={12} mt={"10px"} spacing={4}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                    <Card sx={{ width: "100%", p: "40px" }} classes={{ root: classes.cardStyle }}>
                        <CardContent sx={{ p: "0!important", overflowY: "auto" }}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container item display="flex" alignItems="center">
                                        <Typography fontWeight={600} fontSize={24} color="#404349">
                                            {t('360Evaluation.label.chart')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item>
                                <Grid container mt={1} mb={2}>
                                    <Grid item xs={12} sx={{ height: "400px", position: "relative" }} p={0} display="flex" flexDirection="row">
                                        <Box sx={{
                                            position: "absolute",
                                            left: "-10px",
                                            top: "50%",
                                            transform: "translateY(-50%)"
                                        }}>
                                            <Typography
                                                component="div"
                                                sx={{
                                                    transform: "rotate(-90deg)",
                                                    whiteSpace: "nowrap",
                                                }}
                                                fontSize="18px"
                                                fontWeight="500"
                                                color="#5DA196"
                                                lineHeight={styles.leftRotateLabelLineHeight}
                                            >{t('360Evaluation.label.self')}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", position: "relative", height: "100%", width: "100%" }} ref={scatterChartRefCallback}>
                                            {/* scatter chart */}
                                            <ReactECharts option={scatterChartOptions} opts={{ renderer: 'svg' }} style={{ height: "100%", width: "100%" }} />
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", left: 65, top: 61 }}>
                                                <Typography fontSize={14} fontWeight={500} sx={{ mr: 1 }}>{t('360Evaluation.label.blindSpot')}</Typography>
                                                <CustomTooltip title={t('360Evaluation.label.blindSpotDetail')} placement="top">
                                                    <InfoCircleIcon style={{ width: "12px", height: "12px" }} />
                                                </CustomTooltip>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", right: 13, top: 61 }}>
                                                <Typography fontSize={14} fontWeight={500} sx={{ mr: 1 }}>{t('360Evaluation.label.knownStrength')}</Typography>
                                                <CustomTooltip title={t('360Evaluation.label.knownStrengthDetail')} placement="top">
                                                    <InfoCircleIcon style={{ width: "12px", height: "12px" }} />
                                                </CustomTooltip>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", left: 65, top: 310 }}>
                                                <Typography fontSize={14} fontWeight={500} sx={{ mr: 1 }}>{t('360Evaluation.label.knownAreaForDevelopment')}</Typography>
                                                <CustomTooltip title={t('360Evaluation.label.knownAreaForDevelopmentDetail')} placement="top">
                                                    <InfoCircleIcon style={{ width: "12px", height: "12px" }} />
                                                </CustomTooltip>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", right: 13, top: 310 }}>
                                                <Typography fontSize={14} fontWeight={500} sx={{ mr: 1 }}>{t('360Evaluation.label.hiddenStrength')}</Typography>
                                                <CustomTooltip title={t('360Evaluation.label.hiddenStrengthDetail')} placement="top">
                                                    <InfoCircleIcon style={{ width: "12px", height: "12px" }} />
                                                </CustomTooltip>
                                            </Box>
                                        </Box>
                                        <Box sx={{
                                            position: "absolute",
                                            bottom: 10,
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            pl: "40px"
                                        }}>
                                            <Typography
                                                component="div"
                                                sx={{
                                                    whiteSpace: "nowrap",
                                                }}
                                                fontSize="18px"
                                                fontWeight="500"
                                                color="#5DA196"
                                            >{t('360Evaluation.label.other')}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
                                    <BarLegend data={scatterChartOptions} colors={colorBar}></BarLegend>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        <Button color="primary" onClick={e => changeStep(4)} variant="contained" fullWidth>
                            {t(`label.next`)}
                        </Button>
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        <Button color="black" variant="outlined" fullWidth onClick={e => setActiveStep(2)}>
                            {t('label.back')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const getStepContent = (step) => {
        switch (steps[step]) {
            case "Evaluation Template":
                return evaluationTemplate();
            case "Evaluation Component":
                return showEvaluationTable();
            case "Result":
                return evaluationTemplateStep2();
            case "Evaluation Summary":
                return summaryForm();
            default:
                return null;
        }
    }
    return (
        <Grid direction="column" sx={{}}
            container item
            justifyContent="center"
            alignItems="center">

            <Grid container sx={{ marginBottom: '30px' }}>
                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "30px 260px 29px 255px" }} classes={{ root: classes.error }}>
                    <Stepper activeStep={activeStep} className={classes.root} alternativeLabel>
                        {steps.map((label) => (
                            <Step
                                key={label}
                            >
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Paper>
            </Grid>

            <Grid container item>
                {getStepContent(activeStep)}
            </Grid>
            <SimpleDialog page={true} open={isSuccessOpen} setValue={openSuccessOpen} doDirect={() => handleSuccess()} title={t('mygoal.popup.success')} text={type === 'edit' || type === 'duplicate' ? t('admin.popup.evaluationJourneySave') : t('admin.popup.evaluationJourneyCreate')} />
        </Grid>
    );
};
export default ManageForm;
